












import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'

interface Data {}

interface Methods {
}

interface Computed {}
interface Props {
  text: string
  checked: boolean
  error: boolean
}

export default Vue.extend({
  name: 'UiCheckbox',
  model: {
    prop: 'localChecked',
    event: 'change'
  },
  props: {
    text: {
      type: String,
      default: () => ''
    },
    checked: {
      type: Boolean,
      default: () => false
    },
    error: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      localChecked: this.checked
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
